// NOTE: rightimpact-email-stack provisions its own API Gateway, so this base URL
// is distinct from the direct-snd API. Update it with the `Email Send Batch API
// URL` CfnOutput value after the first `cdk deploy` of the email stack.
export const EMAIL_API_BASE_URL =
  process.env.REACT_APP_EMAIL_API_URL ||
  'https://avuinndjq0.execute-api.us-west-1.amazonaws.com/dev';
